import React from "react";
import { TypeaheadFormField, TypeaheadProps } from "~/components/typeahead";
import { FormFieldProps } from "~/components/forms/FormFieldProps";
import { createSearchRegex } from "~/components/text-highlighter/createSearchRegex";
import { TextHighlighter } from "~/components/text-highlighter";
import { CorpLocation, useCorpLocationsAsync } from "~/refdata2/corpLocations";

const format = (item: CorpLocation, searchText: string): React.ReactNode => {
  const searchRegex = createSearchRegex(searchText);

  return (
    <div className="corp-location-picker-menuitem">
      <TextHighlighter text={item.name} search={searchRegex} />
    </div>
  );
};

const chipFormat = (item: CorpLocation) => item.name;

const CorpLocationPickerFormField: React.FC<FormFieldProps> = (props) => {
  const getCorpLocations = useCorpLocationsAsync();

  const getData = async (searchText: string) => {
    const result = (await getCorpLocations()) ?? [];
    const activeItems = result.filter((x) => x.isActive);

    if (!searchText) {
      return activeItems;
    }

    return activeItems.filter((t) =>
      t.name.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const args = {
    ...props,
    getData,
    format,
    chipFormat,
  } as TypeaheadProps<CorpLocation>;

  return <TypeaheadFormField {...args} />;
};

export default CorpLocationPickerFormField;
